const realpressDropDownPage = () => {
    const dropdownWrapperNodes = document.querySelectorAll('.realpress-wp-dropdown-page-wrapper');
    const restNamespace = REALPRESS_GLOBAL_OBJECT.rest_namespace || '';

    if (!dropdownWrapperNodes) {
        return;
    }
    const {__} = wp.i18n;
    for (let i = 0; i < dropdownWrapperNodes.length; i++) {
        const dropdownWrapperNode = dropdownWrapperNodes[i];
        const dropDownNode = dropdownWrapperNode.querySelector('.realpress-wp-dropdown-page-content .realpress-dropdown');
        const createPageBtnNode = dropdownWrapperNode.querySelector('.realpress-wp-dropdown-page-content > button');
        if (!createPageBtnNode) {
            continue;
        }
        const addPageInlineNode = dropdownWrapperNode.querySelector('.realpress-quick-add-page-inline');
        const addPageActionNode = dropdownWrapperNode.querySelector('.realpress-quick-add-page-actions');
        createPageBtnNode.addEventListener('click', function () {
            dropDownNode.style.display = 'none';
            this.style.display = 'none';
            addPageActionNode.style.display = 'none';
            addPageInlineNode.style.display = 'block';
            addPageInlineNode.querySelector('input').focus();
            addPageInlineNode.querySelector('a').addEventListener('click', function (event) {
                addPageInlineNode.style.display = 'none';
                dropDownNode.style.display = 'block';
                createPageBtnNode.style.display = 'block';
                addPageActionNode.style.display = 'block';
            });

            addPageInlineNode.querySelector('button').addEventListener('click', function (event) {
                event.stopImmediatePropagation();
                const title = addPageInlineNode.querySelector('input').value;
                if (!title) {
                    alert('Please enter the title of page');
                } else {
                    const data = {title, post_type: 'page', post_status: 'publish'};
                    wp.apiFetch({
                        path: '/' + restNamespace + '/page',
                        method: 'POST',
                        data,
                    }).then((res) => {
                            if (res.status && res.status === 'success') {
                                addPageInlineNode.style.display = 'none';
                                dropDownNode.style.display = 'block';
                                createPageBtnNode.style.display = 'block';
                                addPageActionNode.style.display = 'block';
                                const selectControlNode = dropDownNode.querySelector('select.realpress-select2').tomselect;
                                selectControlNode.addOption({value: res.data.id, text: res.data.title});
                                selectControlNode.setValue([res.data.id]);
                                addPageActionNode.querySelector('.edit-page').setAttribute('href', 'post.php?post=' + res.data.id + '&action=edit');
                                addPageActionNode.querySelector('.view-page').setAttribute('href', REALPRESS_GLOBAL_OBJECT.siteurl + '?page_id=' + res.data.id);
                            }
                        }
                    ).catch((err) => {
                        console.log(err);
                    }).finally(() => {
                    });
                }
            });
            addPageInlineNode.querySelector('a').addEventListener('click', function (event) {
                event.preventDefault();
                addPageInlineNode.style.display = 'none';
                dropDownNode.style.display = 'block';
                createPageBtnNode.style.display = 'block';
                addPageActionNode.style.display = 'block';
            });
        });

        const selectNode = dropDownNode.querySelector('select');

        if(selectNode){
            selectNode.addEventListener('change', function () {
                const value = this.value;
                if(value){
                    const editPageNode = addPageActionNode.querySelector('.edit-page');
                    const viewPageNode = addPageActionNode.querySelector('.view-page');
                    let editPageUrl = 'post.php?post=' + value + '&action=edit';
                    let viewPageUrl = REALPRESS_GLOBAL_OBJECT.siteurl + '?page_id=' + value
                    if(editPageNode && viewPageNode){
                        editPageNode.setAttribute('href', editPageUrl);
                        viewPageNode.setAttribute('href', viewPageUrl);
                    }else{
                        addPageActionNode.innerHTML =  `<a class="edit-page" href="${editPageUrl}" target="_blank">`+ __('Edit page', 'realpress')+`</a> |
                        <a class="view-page" href="${viewPageUrl}" target="_blank">`+__('View page', 'realpress')+`</a>`;
                    }

                }else{
                    addPageActionNode.innerHTML = '';
                }
            });
        }
    }
}

export default realpressDropDownPage;
